// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_OcJ","location":"Header_location__2FZC2"};